import http from '../http/http';

import {
    ACTION_TYPES,
    STATUSES,
    ELEMENT_CATEGORIES,
    generateEndpoint,
    INSPECTION_WITH_ADDRESS,
    INSPECTIONS,
    INSPECTIONS_BY_CREATOR,
    INSPECTIONS_BY_PROVIDER,
    ONE_INSPECTION,
    ONE_INSPECTION_BY_EXPORT_TOKEN,
    ONE_INSPECTION_BY_SHARE_TOKEN,
    ONE_INSPECTION_EXPORT,
    INSPECTION_SEARCH,
    OFFICERS,
} from '../http/endpoints';

export default (() => {

    const getOne = (id) => http.get(generateEndpoint(ONE_INSPECTION, { id }));

    const create = (params) => http.post(generateEndpoint(INSPECTIONS), params);

    const createWithAddress = (params) =>
        http.post(generateEndpoint(INSPECTION_WITH_ADDRESS), params);

    const update = (id, params) =>
        http.put(generateEndpoint(ONE_INSPECTION, { id }), params);

    const getOneByShareToken = (token) =>
        http.get(generateEndpoint(ONE_INSPECTION_BY_SHARE_TOKEN, { token }));

    const getOneByExportToken = (token) =>
        http.get(generateEndpoint(ONE_INSPECTION_BY_EXPORT_TOKEN, { token }));

    const getExport = (id) =>
        http.get(generateEndpoint(ONE_INSPECTION_EXPORT, { id }), {
            responseType: 'blob',
        });

    const getElementCategories = () =>
        http.get(generateEndpoint(ELEMENT_CATEGORIES, {}));

    const getActionTypes = () => http.get(generateEndpoint(ACTION_TYPES, {}));
    const getStatuses = () => http.get(generateEndpoint(STATUSES, {}));
    const getOfficers = () => http.get(generateEndpoint(OFFICERS, {}));

    return {
        getOneByShareToken,
        getOneByExportToken,
        getOne,
        getExport,
        create,
        createWithAddress,
        update,
        getElementCategories,
        getActionTypes,
        getStatuses,
        getOfficers,
    };
})();
